import React, { useEffect, useState } from 'react';
import { Banner, Card, Divider, TextField, Spinner, Text } from '@shopify/polaris';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataStart, fetchDataSuccess } from '../../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { getAppOverViewDetails, saveconfigurationsApi, submitAppApi } from '../../../dev_services/developer/api';
import { useParams } from 'react-router-dom';
import SubmitAppDialog from '../../../dev_components/submit_app_dialog/submit_app_dialog';

export default function AppConfiguration() {
    const { appID } = useParams();
    const dispatch = useDispatch();
    const appsResponseData = useSelector((state: any) => state.appsOverviewSlice);
    const { data, loading, error } = appsResponseData;
    const [appURL, setAppURL] = useState('');
    const [websiteURL, setWebsiteURL] = useState('');
    const [termConditonsURL, setTermConditionURL] = useState('');
    const [redirectURL, setRedirectURL] = useState('');
    const [subscriptionURL, setSubscriptionURL] = useState('');
    const [privacyPolicyURL, setPrivacyPolicyURL] = useState('');
    const [faqsURL, setFaqsURL] = useState('');
    const [tutorialsURL, setTutorialsURL] = useState('');
    const [approvedAt, setApprovedAt] = useState('');
    const [submitStatus, setSubmitStatus] = useState('');

    const [appURLError, setAppURLError] = useState('');
    const [redirectURLError, setRedirectURLError] = useState('');
    const [subscriptionURLError, setSubscriptionURLError] = useState('');
    const [privacyPolicyURLError, setPrivacyPolicyURLError] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false); // State to manage the dialog open/close

    const handleOpenDialog = () => {
        setDialogOpen(true); // Open the dialog when the button is clicked
    };

    const handleCloseDialog = () => {
        setDialogOpen(false); // Close the dialog when needed
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching data...");
                dispatch(fetchDataStart());

                // Fetching data from the API
                const response = await getAppOverViewDetails(appID);
                const slugName = response.slug;
                localStorage.setItem('slug', slugName);
                dispatch(fetchDataSuccess(response));
                setAppURL(response.data?.app_info.app_url || '');
                setRedirectURL(response.data?.redirect_url || '');
                setPrivacyPolicyURL(response.data?.privacy_policies_url || '');
                setSubscriptionURL(response.data?.subscription_url || '');
                setApprovedAt(response.data?.approved_at || '');
                setSubmitStatus(response.data?.status || '');
                setWebsiteURL(response.data?.other_urls?.website_url || '')
                setFaqsURL(response.data?.other_urls?.faqs_url || '')
                setTutorialsURL(response.data?.other_urls?.tutorial_url || '')
                setTermConditionURL(response.data?.other_urls?.terms_condition_url || '')
            } catch (error) {
                console.log("Fetched dashboard dataError:");
                console.error("Error fetching dashboard data:", error);
                toast.error("Error fetching data");
            }
        };

        // Fetch data only if appsResponseData is undefined or empty
        if (!data) {
            fetchData();
        } else {
            // Set state variables from the fetched data
            setAppURL(data?.app_info.app_url || '');
            setRedirectURL(data?.redirect_url || '');
            setPrivacyPolicyURL(data?.privacy_policies_url || '');
            setSubscriptionURL(data?.subscription_url || '');
            setApprovedAt(data?.approved_at || '');
            setSubmitStatus(data?.status || '');
            setWebsiteURL(data?.other_urls?.website_url || '')
            setFaqsURL(data?.other_urls?.faqs_url || '')
            setTutorialsURL(data?.other_urls?.tutorial_url || '')
            setTermConditionURL(data?.other_urls?.terms_condition_url || '')
        }
    }, [dispatch, appID, data]);

    const handleAppURLChange = (value) => {
        setAppURL(value);
        if (!value) {
            setAppURLError('App URL is required');
        } else {
            setAppURLError('');
        }
    };

    const handleWebsiteURLChange = (value) => {
        setWebsiteURL(value);
    };
    const handleFaqsURLChange = (value) => {
        setFaqsURL(value);
    };
    const handleTutorialsURLChange = (value) => {
        setTutorialsURL(value);
    };
    const handletermConditionsURLChange = (value) => {
        setTermConditionURL(value);
    };


    const handleRedirectURLChange = (value) => {
        setRedirectURL(value);
        if (!value) {
            setRedirectURLError('Redirect URL is required');
        } else {
            setRedirectURLError('');
        }
    };

    const handleSubscriptionURLChange = (value) => {
        setSubscriptionURL(value);
        if (!value) {
            setSubscriptionURLError('Subscription URL is required');
        } else {
            setSubscriptionURLError('');
        }
    };

    const handlePrivacyPolicyURLChange = (value) => {
        setPrivacyPolicyURL(value);
        if (!value) {
            setPrivacyPolicyURLError('Privacy Policy URL is required');
        } else {
            setPrivacyPolicyURLError('');
        }
    };
    const handleApprovedAt = (value) => {
        setApprovedAt(value);
    };


    const handleSaveConfigurations = async () => {
        try {
            const emptyFields: string[] = [];
            console.log("Saving configurations...");

            // Check if required fields are empty
            if (!appURL) {
                emptyFields.push("App URL");
                setAppURLError('App URL is required');
            } else {
                setAppURLError('');
            }
            if (!redirectURL) {
                emptyFields.push("Redirect URL");
                setRedirectURLError('Redirect URL is required');
            } else {
                setRedirectURLError('');
            }
            if (!subscriptionURL) {
                emptyFields.push("Subscription URL");
                setSubscriptionURLError('Subscription URL is required');
            } else {
                setSubscriptionURLError('');
            }
            if (!privacyPolicyURL) {
                emptyFields.push("Privacy Policy URL");
                setPrivacyPolicyURLError('Privacy Policy URL is required');
            } else {
                setPrivacyPolicyURLError('');
            }

            // If any required field is empty, display an error message
            if (emptyFields.length > 0) {
                const errorMessage = `Please fill in the following required field(s): ${emptyFields.join(", ")}`;
                toast.error(errorMessage);
                return;
            }

            // Construct the configuration object
            const configData = {
                app_id: appID,
                app_info: {
                    app_url: appURL,
                },
                website: websiteURL || null, // Handle optional fields gracefully
                redirect_url: redirectURL,
                subscription_url: subscriptionURL,
                privacy_policies_url: privacyPolicyURL,
                approved_at: approvedAt || null,
                other_urls: {
                    website_url: websiteURL,
                    faqs_url: faqsURL,
                    tutorial_url: tutorialsURL,
                    terms_condition_url: termConditonsURL
                } // Handle optional fields gracefully
            };

            console.log("Configuration data:", configData);

            // Perform the API call to save the configuration
            // You need to implement this function according to your API endpoint
            // For example:
            const saveResponse = await saveconfigurationsApi(configData);
            toast.success("Save Successfully");
            // Display success message if the configuration is saved successfully
            // For example:

        } catch (error) {
            console.error("Error saving configuration:", error);
            toast.error("Error saving configuration");
        }
    };





    if (loading) {
        return (
            <div className="developer-page-frame" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
                <Spinner size="large" />
                <div style={{ marginTop: '20px' }}>
                    <a >Please wait...</a>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="developer-page-frame" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Banner>{error}</Banner>
            </div>
        );
    }

    return (
        <>
            <div className="developer-page-frame" style={{ backgroundColor: "#f6f6f7", paddingLeft: "2.0rem", paddingRight: "2.0rem", paddingTop: "25px" }}>
                <ToastContainer style={{ paddingTop: "50px" }} />
                <div style={{ backgroundColor: "#f6f6f7" }}>
                    <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
                        App Configurations
                    </label>

                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }} className="font-medium text-base w-full sm:w-48">Technical URLs</label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div className="mb-4">
                                    <TextField
                                        autoComplete=''
                                        label="App URL"
                                        value={appURL}
                                        onChange={handleAppURLChange}
                                        placeholder="Enter App Url"
                                    />
                                    {appURLError && <span style={{ color: 'red' }}>{appURLError}</span>}
                                </div>
                                <div className="mb-4">
                                    <TextField
                                        autoComplete=''
                                        label="App Redirect URL"
                                        value={redirectURL}
                                        onChange={handleRedirectURLChange}
                                        placeholder="Enter Redirect Url"
                                        multiline={1}
                                    />
                                    {redirectURLError && <span style={{ color: 'red' }}>{redirectURLError}</span>}
                                </div>
                                <div >
                                    <TextField
                                        autoComplete=''
                                        label="Subscription Url"
                                        value={subscriptionURL}
                                        onChange={handleSubscriptionURLChange}
                                        placeholder="Enter Subscription Url"
                                        multiline={1}
                                    />
                                    {subscriptionURLError && <span style={{ color: 'red' }}>{subscriptionURLError}</span>}
                                </div>
                            </Card>
                        </div>
                    </div>
                    <div style={{ paddingTop: "40px" }}>
                        <Divider />
                    </div>
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }} className="font-medium text-base w-full sm:w-48">Ploicy URLs</label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div className='mb-4'>
                                    <TextField
                                        autoComplete=''
                                        label="Privacy policy Url"
                                        value={privacyPolicyURL}
                                        onChange={handlePrivacyPolicyURLChange}
                                        placeholder="Enter Privacy policy Url"
                                        multiline={1}
                                    />
                                    {privacyPolicyURLError && <span style={{ color: 'red' }}>{privacyPolicyURLError}</span>}
                                </div>
                                <div >
                                    <TextField
                                        autoComplete=''
                                        label="Terms & Condition URL"
                                        value={termConditonsURL}
                                        onChange={handletermConditionsURLChange}
                                        placeholder="Enter Terms & Condition URL*"
                                        multiline={1}
                                    />
                                </div>



                            </Card>
                        </div>
                    </div>
                    <div style={{ paddingTop: "40px" }}>
                        <Divider />
                    </div>
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }} className="font-medium text-base w-full sm:w-48">Others URLs</label>
                        <div className="w-full sm:w-2/3">
                            <Card>

                                <div className="mb-4">
                                    <TextField
                                        autoComplete=''
                                        label="Website Url (Optional)"
                                        value={websiteURL}
                                        onChange={handleWebsiteURLChange}
                                        placeholder="Enter Website Url"
                                        multiline={1}
                                    />
                                </div>
                                <div className="mb-4">
                                    <TextField
                                        autoComplete=''
                                        label="FAQs URL"
                                        value={faqsURL}
                                        onChange={handleFaqsURLChange}
                                        placeholder="Enter FAQs URL"
                                        multiline={1}
                                    />
                                </div>
                                <div >
                                    <TextField
                                        autoComplete=''
                                        label="Tutorial URL"
                                        value={tutorialsURL}
                                        onChange={handleTutorialsURLChange}
                                        placeholder="Enter Tutorial URL"
                                        multiline={1}
                                    />
                                </div>



                            </Card>
                        </div>
                    </div>


                </div>
                <div className="container">
                    {/* <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label style={{ fontFamily: "sfpromedium", fontWeight: "400" }} className="font-medium text-base w-full sm:w-48">Approved At</label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div className="mb-4">
                                    <TextField
                                        autoComplete=''
                                        disabled
                                        label="Approved at"
                                        value={approvedAt}
                                        onChange={handleApprovedAt}
                                        placeholder="Enter Approved at"
                                    />
                                </div>
                            </Card>
                        </div>
                    </div> */}
                    {submitStatus !== "Submitted" && submitStatus !== "Reviewed" ? (
                        <div style={{
                            paddingTop: "30px",
                            gap: "30px",
                            paddingRight: "60px",
                            justifyContent: "end"
                        }} className="flex justify-center">
                            <button style={{ background: "white", color: "black", width: "170px", borderColor: "green", borderWidth: "1px", borderRadius: "7px" }} onClick={handleSaveConfigurations}>
                                <Text variant="bodyMd" as="p">
                                    Save Configuration
                                </Text>
                            </button>
                            <div className="flex justify-center">
                                <button className="button" onClick={handleOpenDialog}>
                                    <Text variant="bodyMd" as="p">
                                        Submit Configuration
                                    </Text>
                                </button>
                            </div>
                            <SubmitAppDialog open={dialogOpen} onClose={handleCloseDialog} />
                        </div>
                    ) : (
                        <div style={{ direction: "rtl", paddingTop: "20px", color: "green" }}>

                            <label style={{ paddingTop: "50px", paddingRight: "150px", justifyContent: "end", fontSize: "20" }}>
                                Your App {submitStatus}Sucessfully
                            </label>

                        </div>
                    )}

                    <div style={{ height: "60px" }}></div>
                </div>
            </div>
        </>
    );
}
